import React from 'react';
import { Typography, Snackbar, Alert } from '@mui/material';
const MAIN_CSS_HREF = '/static/css/main.css';
const useAuthStylesheet = () => {
    React.useEffect(() => {
        if (document.querySelector(`link[href="${MAIN_CSS_HREF}"]`))
            return;
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = MAIN_CSS_HREF;
        document.head.appendChild(link);
    }, []);
};
const AuthLayout = ({ children, width = '100%', snackbarOpen, snackbarMessage, snackbarSeverity, onCloseSnackbar }) => {
    useAuthStylesheet();
    return (React.createElement("div", { id: "fullPage" },
        React.createElement("div", { id: "brandingWrapper", className: "float" },
            React.createElement("div", { id: "branding", className: "illustrationClass" })),
        React.createElement("div", { id: "contentWrapper", className: 'float' },
            React.createElement("div", { id: "content" },
                React.createElement("div", { id: "header" },
                    React.createElement(Typography, { variant: 'h4' }, "Agriculture")),
                React.createElement("div", { id: "workArea" }, children)),
            React.createElement("div", { id: "footer" },
                React.createElement("div", { id: "footerLinks" },
                    React.createElement(Typography, { variant: 'caption' }, "\u0412\u041A\u0423 \u0438\u043C. \u0421.\u0410\u043C\u0430\u043D\u0436\u043E\u043B\u043E\u0432\u0430")))),
        React.createElement(Snackbar, { open: snackbarOpen, autoHideDuration: 6000, onClose: onCloseSnackbar, anchorOrigin: { vertical: 'bottom', horizontal: 'right' } },
            React.createElement(Alert, { onClose: onCloseSnackbar, severity: snackbarSeverity, sx: { width: '100%' } }, snackbarMessage))));
};
export default AuthLayout;
